import { get, post, getDelete } from '../../index.js'
import base from '../../base.js'

export const getCustomerVisit = (params) => get(base.getCustomerVisit, params)
export const postCustomerVisit = (params) => post(base.customerVisit, params)
export const getCustomerVisitStar = (params) => get(base.customerVisitStar, params)
export const getCustomerVisitMode = (params) => get(base.customerVisitMode, params)
export const postCustomerVisitApprove = (params) => post(base.customerVisitApprove, params)
export const deleteCustomerVisitHtml = (id) => getDelete(`${base.customerVisitHtml}/${id}`)
